import { InstanceScreen } from 'component/navigation/instance';

export default function EditorialDashboardAdminsScreen() {
    return <InstanceScreen screenKey='admins' />;
}
